// Define experiment feature code constants (e.g., const MY_EXPERIMENT = 'my_experiment') below
// <<Stencil::Block(clientFeatureCodeDefinitions)>>
export const COURSE_CARDS_OPEN_IN_NEW_TAB = 'course_cards_open_in_new_tab';
export const COURSE_GUIDANCE_FEATURE = 'course_guidance_feature';
export const DELAY_COURSE_CARD_QUICK_VIEW_BOX = 'delay_course_card_quick_view_box';
export const DESKTOP_POST_ADD_TO_CART_BEHAVIOR = 'desktop_post_add_to_cart_behavior';
export const HIDE_WISHLIST_BUTTON_ON_COURSE_CARD_QUICK_VIEW_BOX =
    'hide_wishlist_button_on_course_card_quick_view_box';
export const LEARNERS_ARE_VIEWING_ON_LOHP = 'learners_are_viewing_on_lohp';
export const POPULAR_CATEGORIES_MODULE = 'popular_categories_module';
export const POPULAR_CATEGORIES_MODULE_FOR_LOHP = 'popular_categories_module_for_lohp';
export const SHOW_TRENDING_SKILLS_ABOVE_AI_ERA_CAREER_BANNER =
    'show_trending_skills_above_ai_era_career_banner';
export const PERSONAL_PLAN_BANNER_VALUE_PROP_REVAMP = 'pp_module_value_prop_revamp';
export const MOBILE_WEB_OPTIMIZATION = 'mobile_web_optimization';
export const LOHP_VERTICAL_MOBILE_RECO_UNITS = 'lohp_vertical_mobile_reco_units';
export const FBT_FORCE_GO_TO_CART = 'fbt_force_go_to_cart';
export const SHOW_VERNACULAR_CONTENT = 'show_vernacular_content';
export const LOHP_CAROUSEL_HOVER_POPUP_REMOVAL = 'lohp_carousel_hover_popup_removal';
// Consumed by @udemy-v2/react-header and @udemy-v2/react-browse-course on this page.
export const VALUE_PLAN_STARTER_PLAN = 'value_planstarter_plan';
// @udemy-v2/react-header reads this same experiment itself (separately) to pick its
// mobile search UI; we read it here only to match Enriched Skills' mobile spacing.
export const MWEB_SEARCH_HEADER_OPTIMIZATION = 'mweb_search_header_optimization';
// <</Stencil::Block>>

// Experimentation codes that will be evaluated client-sidea across all pages.
export const CLIENT_FEATURE_CODES_ALL: string[] = [
    // Add feature code constants to evaluate client-side across all pages below
    // <<Stencil::Block(globalClientFeatureCodes)>>
    COURSE_CARDS_OPEN_IN_NEW_TAB,
    COURSE_GUIDANCE_FEATURE,
    DELAY_COURSE_CARD_QUICK_VIEW_BOX,
    DESKTOP_POST_ADD_TO_CART_BEHAVIOR,
    HIDE_WISHLIST_BUTTON_ON_COURSE_CARD_QUICK_VIEW_BOX,
    LEARNERS_ARE_VIEWING_ON_LOHP,
    POPULAR_CATEGORIES_MODULE,
    POPULAR_CATEGORIES_MODULE_FOR_LOHP,
    SHOW_TRENDING_SKILLS_ABOVE_AI_ERA_CAREER_BANNER,
    PERSONAL_PLAN_BANNER_VALUE_PROP_REVAMP,
    MOBILE_WEB_OPTIMIZATION,
    LOHP_VERTICAL_MOBILE_RECO_UNITS,
    FBT_FORCE_GO_TO_CART,
    SHOW_VERNACULAR_CONTENT,
    VALUE_PLAN_STARTER_PLAN,
    MWEB_SEARCH_HEADER_OPTIMIZATION,
    LOHP_CAROUSEL_HOVER_POPUP_REMOVAL,
    // <</Stencil::Block>>
];
